'use strict'

module.exports  = {

    firebase: {
        apiKey: "AIzaSyB4M7WNvYbGJ6-9s1yoo4Y3oAH-2KCBL6A",
        authDomain: "smbiz-prod.firebaseapp.com",
        databaseURL: "https://smbiz-prod.firebaseio.com",
        projectId: "smbiz-prod",
        storageBucket: "smbiz-prod.appspot.com",
        messagingSenderId: "636673448491",
        appId: "1:636673448491:web:8477633b7a93746bab686e",
        measurementId: "G-8LH26EMPTD"
    },

    publicVapidKey: 'BCPxsrUTx1JZwuXMJs-luCxzeRR2BZRTRlYLR5EArb5W280HAGMl02Pq8o-G9SC0BhvUgo-SG3uJtBQJ0EjqFTI',

    // ペイウォールからのアクセス元としてローカルストレージへの登録を許可するドメイン
    // リンク元として以下ドメインがマッチした場合のみ、ローカルストレージへ保存する
    allowedAccessFromPaywallDomain: /https:\/\/smbiz.asahi.com\/article\//,

    // /messageのページURI
    // SNS認証でメアド確認が完了した後の再ログイン時に、ポップアップ文を表示する際に使用
    messagePageURI: /https:\/\/smbiz.asahi.com\/message/,

    // プロフィール登録後にリダイレクトするURL
    profileRegistedPageURI: '/tag/10772028',

    recaptchaSiteKey : "6LfCKKkZAAAAAE44SLG8KRi6uXDUN_2oWTzSIhND",

    path: {
        signup: '/member/signup/',
        login: '/member/login/',
        profile: '/member/profile/',
        forgotpw: '/member/forgetpw/',
        registmail: '/member/registermail/',
        changemail: '/member/changemail/',
        changepasswd: '/member/changepw/',
        usermgmt: '/member/usermgmt/',
        withdrawal: '/member/withdrawal/',
        terms: '/terms/',
    },

    api: {
        sessionState: '/papi/v1/auth/sessionstate',
        verifyEmail: '/papi/v1/auth/verifyEmail',
        signUpEmail: '/papi/v1/auth/signUpEmail',
        resetPassword: '/papi/v1/auth/resetPassword',
        encryption: '/papi/v1/auth/encryption',
        sessionCookie: '/papi/v1/auth/session',
        deleteSessionCookie: '/papi/v1/auth/d_session',
        checkBot: '/papi/v1/auth/botCheck',
        thanksEmail: '/papi/v1/auth/thanksEmail',
        updateEmailAddressTemporaryRemove: 'https://asia-northeast1-smbiz-prod.cloudfunctions.net/updateEmailAddressTemporaryRemove',
        updateEmailAddressReAddRecipient: 'https://asia-northeast1-smbiz-prod.cloudfunctions.net/updateEmailAddressReAddRecipient',
    },

    // フォーム入力値
    form: {
        sei: null,                              // 姓
        seiSub: null,                           // 姓（ふりがな）
        mei: null,                              // 名
        meiSub: null,                           // 名（ふりがな）
        birthdayY: '1980',                      // 生年月日（年）※初期値を1980と指定
        inheritanceExperience: [],              // 事業承継に対する経験
        inheritanceExperienceForView: null,     // 事業承継に対する経験の選択値をフロント側で表示する際の値
        isSubscribe: true,                      // メルマガ登録フラグ※初期値は'yes'を指定
    },

    // メルマガ登録
    isSubscribe: {
        yesView: '登録する',
        noView: 'しない',
    },

    // プロバイダ名の判別は以下で行う
    providers: {
        facebook:   'facebook.com',
        email:      'password'
    },

    // firestoreのコレクション名情報
    collections: {
        // ユーザ情報を一元して格納しているfirestoreのコレクション名
        userData: 'users',
        // SNSデータ取得時にfirestoreへ取得データを一時格納する際のコレクション名
        storedSnsProfile: {
            facebook: 'facebookProfile',
        },
        // 退会ユーザのデータ
        withdrawalUsers: 'withdrawalUsers',
        // firestoreの設定のデータ
        firestoreSetting: '_config'
    }
}
